import type { ReactNode } from 'react';

interface PageSectionProps {
  children: ReactNode;
  className?: string;
  eyebrow?: string;
  title?: string;
  description?: string;
}

export function PageSection({
  children,
  className = '',
  eyebrow,
  title,
  description,
}: PageSectionProps) {
  return (
    <section className={`mx-auto w-full px-6 ${className}`}>
      {(eyebrow || title || description) && (
        <div className="mb-6 max-w-3xl">
          {eyebrow && (
            <p className="mb-2 text-xs font-black uppercase tracking-[0.18em] text-aws-blue">
              {eyebrow}
            </p>
          )}
          {title && <h2 className="text-2xl font-black tracking-tight text-aws-ink sm:text-3xl">{title}</h2>}
          {description && <p className="mt-2 leading-7 text-aws-slate">{description}</p>}
        </div>
      )}
      {children}
    </section>
  );
}
